import ClickAwayListener from '@mui/base/ClickAwayListener'
import { Fab, styled, TextField, Paper } from '@mui/material'
import { useFormik } from 'formik'

import { useRefreshSignal } from '../../contexts/refreshSignal'

const StyledForm = styled('form')(() => ({
  display: 'flex',
  flexDirection: 'column'
}))

const StyledTextField = styled(TextField)(() => ({
  marginBottom: '1rem'
}))

const StyledPaper = styled(Paper)(({ theme }) => ({
  // margin: '1rem',
  // border: '1px solid green',

  elevation: 9,
  marginLeft: '2rem',
  marginRight: '2rem',
  marginBottom: '2rem',
  padding: '1rem',
  borderRadius: '1rem',
  border: '1px solid #e0e0e0',
  boxShadow: theme.palette.mode === 'dark'? '0 0 20rem 0 white' : '0 0 2rem 0 grey'

}))

/**
 * This sets a container at the bottom of the page
 */
const OverlayBottomContainer = styled('div')(() => ({
  position: 'fixed',
  bottom: '4.5rem',
  left: 0,
  width: '100%',
  zIndex: 1000
}))

export const AddSasaviForm = ({
  createItem,
  setShowAddSasaviForm,
  setFilterLiked
}) => {
  const { triggerRefresh } = useRefreshSignal()

  const formik = useFormik({
    initialValues: {
      url: '',
      comment: '',
      createdAt: null,
      files: []
    },
    onSubmit: async (values, { resetForm }) => {
      if (!values.url && !values.comment) {
        return
      }
      await createItem({ ...values, createdAt: new Date() })
      setFilterLiked(false)
      // Scroll to top after adding a new item
      window.scrollTo({ top: 0, behavior: 'smooth' })
      // triggerRefresh()
      resetForm()
    },
    onReset: async () => {
      // Signal Main.js to refresh the list
      setShowAddSasaviForm(false)
      triggerRefresh()
    }
  })

  return (
    <OverlayBottomContainer>
      <ClickAwayListener onClickAway={() => setShowAddSasaviForm(false)}>
        <StyledPaper>
      <StyledForm onSubmit={formik.handleSubmit}>
        <StyledTextField
          multiline
          rows={'4'}
          id="comment"
          label="sasavi it!"
          variant="outlined"
          onChange={formik.handleChange}
          value={formik.values.comment}
        />
        <input
          id="files"
          name="files"
          type="file"
          multiple
          onChange={(e) => {
            const files = Array.from(e.currentTarget.files || [])
            console.log('selected files:', files)
            formik.setFieldValue('files', files)
          }}
        />
        {/* <MyTextField id="url" label="url" variant="outlined" type='url' onChange={formik.handleChange} value={formik.values.url} /> */}
        <Fab  type="submit" variant="extended" color="primary" value="sasavi it!">
          sasavi it!
        </Fab>
      </StyledForm>
        </StyledPaper>
      </ClickAwayListener>
    </OverlayBottomContainer>
  )
}